import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop, Header, Home, Footer } from "./components";
import {
  TradingPlatforms,
  CRM,
  Technologies,
  Help,
  AboutUs,
  Error,
  PrivacyPolicy,
  Cookies,
  Terms,
  CookiePreferences,
} from "./pages";
import { CookiesProvider } from "react-cookie";

function App() {
  return (
    <CookiesProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <React.Fragment>
                <Home />
              </React.Fragment>
            }
          ></Route>
          <Route
            path="/trading-platforms"
            element={<TradingPlatforms />}
          ></Route>
          <Route path="/back-office" element={<CRM />}></Route>
          <Route path="/technologies" element={<Technologies />}></Route>
          <Route path="/help" element={<Help />}></Route>
          <Route path="/about-us" element={<AboutUs />}></Route>
          <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/cookies" element={<Cookies />}></Route>
          <Route path="/terms-and-conditions" element={<Terms />}></Route>
          <Route
            path="/cookie-preferences"
            element={<CookiePreferences />}
          ></Route>
          <Route path="*" element={<Error />}></Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </CookiesProvider>
  );
}

export default App;
